
import Masthead from './components/Masthead';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Projects from './pages/Projects'; 
import ContactUs from './pages/ContactUs'; 
import './App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import emailjs from '@emailjs/browser';
import './assests/bootstrap-4.3.1-dist/css/bootstrap.css'
import './assests/bootstrap-4.3.1-dist/css/bootstrap.min.css'
import AppRoutes from './AppRoutes';

function App() {

  useEffect(() => {
    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.target.classList.contains('preview')) {
          const box = entry.target;
          const img = box.querySelector('.abs-img');
          if (!img.classList.contains('hover-preview')) {
            
             // add preview effect after 200 ms
             setTimeout(() => {
              img.classList.add('hover-preview');
            }, 150);
           
          }
           // Remove preview effect after 3 seconds
           setTimeout(() => {
            img.classList.remove('hover-preview');
          }, 3500);
        }
      });
    };

    const observerOptions = { threshold: 0.1 };
    const intersectionObserver = new IntersectionObserver(observerCallback, observerOptions);

    const observeBoxes = () => {
      const boxes = document.querySelectorAll('.box');
      boxes.forEach((box) => intersectionObserver.observe(box));
    };

    // Initial observation
    observeBoxes();

    // Monitor DOM for new `.box` elements
    const mutationObserver = new MutationObserver(() => {
      observeBoxes();
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });

    
    return () => {
      intersectionObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, []);


  useEffect(() => {
    AOS.init({
      duration: 1500,
      offset: 120,
    });
    AOS.refresh();

    const preloadedImgs=(urls)=>{
      urls.forEach((url) =>{
        const img =new Image();
        img.src = url;
      })
    }
    preloadedImgs([
      'assests/imgs/Stock-1.webp',
    ])

    emailjs.init({
      publicKey: 'KvLCTJKtgGwsJaglg', 
      blockHeadless: true, 
    });
    
  }, []);
  
  

  return (

      <div className="App">
        <Masthead />
        <AppRoutes />        
        <Footer />
      </div>
  
  );
}

export default App;
